import { create as createAxiosClient } from 'axios';

import { config } from '../app/bootstrap/environment';

/**
 * Single shared axios client for the Contract Entry API, used by every `api/*` module
 * (`api.ts`'s Contracts endpoints, `templatesApi.ts`'s Templates endpoints) — there is exactly
 * one Contract Entry API, so there is exactly one client for it.
 *
 * Unlike the Pricing Engine reference app's `apiClient.ts` (where `templatesApi.ts` originated),
 * this never attaches an Authorization header: the Contract Entry API Gateway has no authorizer
 * configured (see `services/api/cdk/lib/AppStack.ts`) — access is already gated upstream by
 * `AuthGate`/Cognito, not per-request tokens here.
 */
export const apiClient = createAxiosClient({
  baseURL: config.api.baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});
